/**
 * SelectField Component
 *
 * select/dropdown 타입 필드를 렌더링하는 컴포넌트
 * shadcn/ui Select 컴포넌트 사용
 */

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';

import type { BaseFieldProps } from './types';

/**
 * 드롭다운 선택 필드
 *
 * select와 dropdown 타입 모두 이 컴포넌트로 렌더링됨
 */
export function SelectField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Select
        disabled={disabled}
        value={(value as string) || undefined}
        onValueChange={(val) => onChange(val)}
      >
        <SelectTrigger
          className="h-12 rounded-md px-4 text-base border-[#d9dde0]"
          aria-invalid={!!error}
        >
          <SelectValue placeholder={field.placeholder || '선택하세요'} />
        </SelectTrigger>
        <SelectContent>
          {field.options?.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
